























import Vue from "vue";
import { ExtOrderItem, InvoiceItem, InvoiceRelationType, SalesAndOpportunity, Stock } from "../models";
import { formatDate } from "@/utils/formatDates";
import GPart, { getFlags } from "@/modules/gpartsEdit/models/GPart";
import { t } from "@/plugins/i18n";

const displayNames = (item: InvoiceItem) => {
  const result = [];
  
  const stock = item.relations.find((i) => i.type === InvoiceRelationType.Stock)?.relatedItem as Stock;
  if (stock && !item.isService) {
    result.push(t("InvoiceItems_Szallitolevel", [stock.deliveryNumber ?? "-"]));
    if (stock.orderNumber) {
      result.push(t("InvoiceItems_RendelesSzama", [stock.orderNumber]));
    }
    return result;
  }

  const orderItem = item.relations.find((i) => i.type === InvoiceRelationType.ExtOrderItem)?.relatedItem as ExtOrderItem;
  if (orderItem) {
    result.push(
      orderItem.orderNumber ? t("InvoiceItems_RendelesSzama", [orderItem.orderNumber]) : item.orderNumber ? item.orderNumber : "",
      (orderItem.originalStock > 1) ? t("InvoiceItems_StockCsereje", [orderItem.originalStock]) : ""
    );
    return result.filter((i) => i);
  }

  const salesOrderRelation = item.relations.find((r) => r.type === InvoiceRelationType.SalesOrder);
  if (salesOrderRelation) {
    const salesOrderData = salesOrderRelation.relatedItem as SalesAndOpportunity;
    result.push(t("InvoiceItems_Ertekesites", [salesOrderData.salesOrderNo]))
    return result;
  }

  if (item.car > 1 || item.prCar > 1) {
    result.push(`Modell: ${item.carDetails.model}`, t("InvoiceItems_Alvazszam", [item.carDetails.bodyNo]));
    if (item.car > 1) {
      result.unshift(t("InvoiceItems_Gepjarmu", [item.car]));
    } else {
      result.unshift(t("InvoiceItems_GepjarmuRendeles", [item.prCar]));
    }
    return result;
  }

  if ((item as any).bodyNo) {
    result.push(t("InvoiceItems_Alvazszam", [(item as any).bodyNo]));
  }

  const service = item.relations.find((i) => i.type === InvoiceRelationType.Service)?.relatedItem as GPart;
  if (service) {
    result.unshift(t("InvoiceItems_Cikkszam", [service.code ?? "-"]));
  }
  return result;
};

const toolTipInfos = (item: InvoiceItem) => {
  const stock = item.relations.find((i) => i.type === InvoiceRelationType.Stock)?.relatedItem as Stock;
  const result = [];
  if (stock) {
    result.push(t("InvoiceItems_Betarolas", [stock.storeInID]));
    result.push(t("InvoiceItems_BetarolasDatuma", [formatDate(new Date(stock.stockDate))]));
    result.push(`Batch: ${stock.batchNumber}`);
    result.push(t("InvoiceItems_Cikkszam", [stock.productCode]));
  }

  return result;
}

const serviceFlags = (item: InvoiceItem) => {
  const service = item.relations.find((i) => i.type === InvoiceRelationType.Service)?.relatedItem as GPart;
  if (service) {
    return getFlags(service);
  }
}

export default Vue.extend({
  props: {
    item: {
      type: Object as () => InvoiceItem,
    },
  },

  computed: {
    displayNames() {
      return displayNames(this.item);
    },

    toolTipInfos() {
      return toolTipInfos(this.item);
    },

    flags() {
      return serviceFlags(this.item);
    }
  },
});
